module.exports = __webpack_public_path__ + "img/Talk Graphic 9.a1d40b9a.png";